export class JSONHandlerActions{
  static REGISTER = 'REGISTER';
  static REMIND   = 'REMIND';
  static CONFIRM  = 'CONFIRM';
  static LOGIN    = 'LOGIN';
}
